<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <line-chart class="col-span-2 bg-white overflow-hidden shadow rounded-lg mb-4 p-4"
                :chart-data="reportsPerMonth"/>
  </div>
</template>
<script>
import ReportDatePicker from '@/views/admin/reports/ReportDatePicker'
import LineChart from '@/components/Charts/LineChart'
import ReportService from '@/services/ReportService'

export default {
  components: {
    LineChart,
    ReportDatePicker,
  },
  props: {
    dateFrom: {
      type: String,
      default: '',
    },
    dateTill: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      year: new Date().getFullYear(),
      loading: false,
      resumeTotals: {
        results: []
      }
    }
  },
  computed: {
    reportParams () {
      return {
        model: 'resumes',
        group: 'month',
        select: 'id,total',
        date_range: 'custom',
        date_from: this.dateFrom,
        date_till: this.dateTill,
        sort: 'date_month',
      }
    },
    reportsPerMonth () {
      return {
        labels: this.resumeTotals.results.map(r => this.$formatDate(r.date_format, 'MMM')),
        datasets: [
          {
            label: this.$t('reports.createdResumes'),
            borderColor: '#5145cd',
            pointBackgroundColor: '#5145cd',
            data: this.resumeTotals.results.map(r => ({
              x: new Date(this.year, r.date_month - 1, 1),
              y: r.total
            }))
          },
        ]
      }
    }
  },
  methods: {
    async getReports () {
      try {
        this.loading = true
        await Promise.all([
          this.getResumeReport(),
        ])
      } finally {
        this.loading = false
      }
    },
    async getResumeReport () {
      const {data} = await ReportService.get(this.reportParams)
      this.resumeTotals = data
    }
  },
  watch: {
    dateFrom () {
      this.getReports()
    },
    dateTill () {
      this.getReports()
    }
  },
  mounted () {
    this.getReports()
  }
}
</script>
<style>
</style>
